import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "../ui-component/Loadable";

import SocioCuenta from "../pages/socio-cuenta";
import SocioPerson from "../pages/socio";
import Create from "../pages/socio/Create/Create";
import HomePage from "pages/Home/HomePage";
import Dashboard from "../views/dashboard/Default";

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import("../views/dashboard/Default")));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import("../views/utilities/Typography")));
const UtilsColor = Loadable(lazy(() => import("../views/utilities/Color")));
const UtilsShadow = Loadable(lazy(() => import("../views/utilities/Shadow")));
const UtilsMaterialIcons = Loadable(lazy(() => import("../views/utilities/MaterialIcons")));
const UtilsTablerIcons = Loadable(lazy(() => import("../views/utilities/TablerIcons")));

// sample page routing
const SamplePage = Loadable(lazy(() => import("../views/sample-page")));

//person
const CrudPerson = Loadable(lazy(() => import("../pages/person/Person")));
const NuevoPersonaForm = Loadable(lazy(() => import("pages/person/Create/NuevoPersonaForm")));

//const CuentaSocio = Loadable(lazy(() => import("../pages/socio/ListSocio")));
const CrudCaja = Loadable(lazy(() => import("../pages/transaction/Caja")));
const CrudAperturaCaja = Loadable(lazy(() => import("../pages/transaction/AperturaCaja/index")));
const CrudEstadoCuenta = Loadable(lazy(() => import("../pages/transaction/EstadoCuenta/index")));

// Solicitud de Credito
const CrudSolicitudCredito = Loadable(lazy(() => import("../pages/credito/SolicitudCredito")));

const AprobarNegar = Loadable(lazy(() => import("../pages/credito/AprobarNegar")));

const CrudGarantes = Loadable(lazy(() => import("../pages/credito/Garantes")));
const CrudTablaAmortizacion = Loadable(lazy(() => import("../pages/credito/TablaAmortizacion")));
const CrudFlujos = Loadable(lazy(() => import("../pages/credito/Flujos")));
const CrudCincoC = Loadable(lazy(() => import("../pages/credito/CincoC")));
const CrudPagoCredito = Loadable(lazy(() => import("../pages/transaction/PagoCredito")));
const CrudCajaArchivo = Loadable(lazy(() => import("../pages/transaction/CajaArchivo")));
// Nuevos Pagos Anticipados
const CrudPagoAnticipados = Loadable(lazy(() => import("../pages/transaction/PagoAnticipado")));
// Tesoreria
const CrudListaGastos = Loadable(lazy(() => import("../pages/tesoreria/ListaGastos")));
const NuevoRegistroGasto = Loadable(lazy(() => import("pages/tesoreria/Create/NuevoGastoForm")));
// Contabilidad
const ListaPlanCuentas = Loadable(lazy(() => import("../pages/contabilidad/ListaPlanCuentas")));
const NuevoPlanCuentas = Loadable(lazy(() => import("pages/contabilidad/Create/NuevoPlanCuentaForm")));

const ListaProcesoContable = Loadable(lazy(() => import("../pages/contabilidad/ListaProcesoContable")));
const NuevoProcesoContable = Loadable(lazy(() => import("pages/contabilidad/Create/NuevoProcesoContableForm")));

const ListaDetailProcesoContable = Loadable(lazy(() => import("../pages/contabilidad/ListaDetailProcesoContable")));
const NuevoDetailProcesoContable = Loadable(lazy(() => import("../pages/contabilidad/Create/NuevoDetailPlanCuentaForm")));

//Reportes
const BalanceGeneral = Loadable(lazy(() => import("../pages/reporte/BalanceGeneral")));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: "/home",
    element: <MainLayout />,
    children: [
        
        {
            index: true,
            element: <Dashboard />,
        },
        {
            path: "dashboard/default",
            element: <DashboardDefault />,
        },
        {
            path: "utils/util-typography",
            element: <UtilsTypography />,
        },
        {
            path: "utils/util-color",
            element: <UtilsColor />,
        },
        {
            path: "utils/util-shadow",
            element: <UtilsShadow />,
        },
        {
            path: "icons/tabler-icons",
            element: <UtilsTablerIcons />,
        },
        {
            path: "icons/material-icons",
            element: <UtilsMaterialIcons />,
        },
        {
            path: "sample-page",
            element: <SamplePage />,
        },
        {
            path: "person",
            element: <CrudPerson />,
        },
        {
            path: "person/new",
            element: <NuevoPersonaForm />,
        },
        {
            path: "person/:id",
            element: <NuevoPersonaForm />,
        },
        {
            path: "socio",
            element: <SocioPerson />,
        },
        {
            path: "account",
            element: <SocioCuenta />,
        },
        {
            path: "socio/new",
            element: <Create />,
        },
        {
            path: "AperturaCaja",
            element: <CrudAperturaCaja />,
        },
        {
            path: "caja",
            element: <CrudCaja />,
        },
        {
            path: "estadoCuenta",
            element: <CrudEstadoCuenta />,
        },
        // Cruds para Credito
        {
            path: "solicitudCredito",
            element: <CrudSolicitudCredito />,
        },
        {
            path: "garantes",
            element: <CrudGarantes />,
        },
        {
            path: "tablaAmortizacion",
            element: <CrudTablaAmortizacion />,
        },
        {
            path: "flujos",
            element: <CrudFlujos />,
        },
        {
            path: "cincoC",
            element: <CrudCincoC />,
        },
        {
            path: "aprobarNegar",
            element: <AprobarNegar />,
        },
        {
            path: "PagoCredito",
            element: <CrudPagoCredito />,
        },
        {
            path: "CajaArchivo",
            element: <CrudCajaArchivo />,
        },
        // Pagos Anticipados
        {
            path: "PagoAnticipado",
            element: <CrudPagoAnticipados />,
        },
        // Tesoreria
        {
            path: "gastos",
            element: <CrudListaGastos />,
        },
        {
            path: "gastos/new",
            element: <NuevoRegistroGasto />,
        },
        //Contabilidad
        {
            path: "planCuenta",
            element: <ListaPlanCuentas />,
        },
        {
            path: "planCuenta/new",
            element: <NuevoPlanCuentas />,
        },
        {
            path: "procesoContable",
            element: <ListaProcesoContable />,
        },
        {
            path: "procesoContable/new",
            element: <NuevoProcesoContable />,
        },
        {
            path: "detailProcesoContable",
            element: <ListaDetailProcesoContable />,
        },
        {
            path: "detailProcesoContable/new",
            element: <NuevoDetailProcesoContable />,
        },
        //Reporte
        {
            path: "balanceGeneral",
            element: <BalanceGeneral />,
        },
    ],
};

export default MainRoutes;